import React from "react";
import { Select } from "antd";
import { ManualStockEntryStockType } from "services/BillingEngineService/interfaces/entities/ManualStockEntry";
import { SelectProps } from "antd/lib/select";

const { Option } = Select;

interface IStockTypeSelect extends Omit<SelectProps<any>, "onSelect"> {
  onSelect: (value: ManualStockEntryStockType) => void;
}

const stockTypeOptions: {
  value: ManualStockEntryStockType;
  label: string;
}[] = [
  {
    label: "Standard Pallet",
    value: "palletStandard",
  },
  {
    label: "Double Pallet",
    value: "palletDouble",
  },
  {
    label: "Bin",
    value: "bin",
  },
  {
    label: "Box",
    value: "box",
  },
  {
    label: "Shelf",
    value: "shelf",
  },
];

function StockTypeSelect({ onSelect, ...rest }: IStockTypeSelect) {
  function handleSelect(key: string) {
    const matchingOption = stockTypeOptions.find((option) => option.value === key);

    if (matchingOption) {
      onSelect(matchingOption.value);
    }
  }

  return (
    <Select style={{ width: "100%" }} placeholder="Select Stock Type" onSelect={handleSelect} {...rest}>
      {stockTypeOptions.map((option) => {
        return (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        );
      })}
    </Select>
  );
}

export default StockTypeSelect;
